import { SystemRepository } from '../repositories'

export interface GetItemListByCategoryParamsBo extends SystemRepository.GetItemListByCategoryReqDto {}

export interface GetItemListByCategoryRespBo extends SystemRepository.GetItemListByCategoryRespDto {}

/** 取得系統項目清單 */
export async function getItemListByCategory(params: GetItemListByCategoryParamsBo): Promise<GetItemListByCategoryRespBo> {
  const itemListDto = await SystemRepository.getItemListByCategory(params)

  return itemListDto
}

export interface AddItemByCategoryParamsBo extends SystemRepository.AddItemByCategoryReqDto {}

/** 新增系統項目 */
export async function addItemByCategory(params: AddItemByCategoryParamsBo) {
  await SystemRepository.addItemByCategory(params)
}

export interface GetItemByCategoryParamsBo extends SystemRepository.GetItemByCategoryReqDto {}

export type GetItemByCategoryRespBo = SystemRepository.GetItemByCategoryRespDto

/** 取得系統項目 */
export async function getItemByCategroy(params: GetItemByCategoryParamsBo): Promise<GetItemByCategoryRespBo> {
  const itemDto = await SystemRepository.getItemByCategroy(params)

  return itemDto
}

export interface DeleteItemByCategoryParamsDto extends SystemRepository.DeleteItemByCategoryReqDto {}

/** 刪除系統項目 */
export async function deleteItemByCategroy(params: DeleteItemByCategoryParamsDto) {
  await SystemRepository.deleteItemByCategroy(params)
}

export interface UpdateItemByCategoryParamsDto extends SystemRepository.UpdateItemByCategoryReqDto {}

/** 更新系統項目 */
export async function updateItemByCategroy(params: UpdateItemByCategoryParamsDto) {
  await SystemRepository.updateItemByCategroy(params)
}
